import { ConsentAction, ConsentType, IConsent } from "types/consent";

import { getBulkConsentManager } from "helpers/consent/BulkConsentManager";
import WidgetConfig from "helpers/init/WidgetConfig";
import { bulkLogger } from "helpers/logger";
import createPromise from "helpers/createPromise";

const saveBulkConsent = (
  bulkConfig: WidgetConfig["bulkConsent"],
  payload: ISaveBulkConsentPayload
) => {
  return createPromise((resolve) => {
    const { id, iframeUrl } = bulkConfig;
    const msg = {
      group_id: id,
      action: "set",
      consent: payload,
    };
    const manager = getBulkConsentManager(iframeUrl);
    manager.sendMessage(msg).then(
      () => resolve(),
      (e) => {
        bulkLogger("Failed to save bulk consent", { error: e });
        resolve();
      }
    );
  });
};

export interface ISaveBulkConsentPayload {
  action: ConsentAction;
  consent: IConsent | Record<string, never>;
  timestamp: number;
  type: ConsentType;
  // TCF fields — optional, included when TCF is enabled
  tcString?: string;
  acString?: string;
}

export default saveBulkConsent;
